<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>プラスの氣 ランキング</template>
    </PageHeader>

    <div class="text-center px-3">
      <v-row>
        <DatePicker v-model="searchForm.dateFrom" label="表示開始日" />
        <DatePicker v-model="searchForm.dateTo" label="表示終了日" />
        <v-col cols="6" sm="6" md="4">
          <Button @click="getRanking()" color="primary" v-if="isNotProcess"
            >絞り込み</Button
          >
        </v-col>
      </v-row>
      <v-row
        ><v-col class="pt-0 pb-0 pl-0 pr-0 mt-n5 mb-n2"
          ><Loader :loading="loading" /></v-col
      ></v-row>
      <v-row class="mb-5">
        <v-col cols="12" md="6">
          <RecieveRanking
            v-if="showChild"
            :pageKind="rankingPageName"
            :biginDay="searchForm.dateFrom"
            :endDay="searchForm.dateTo"
            @catchRecvMessage="displayRecvMessage"
          />
        </v-col>
        <v-col cols="12" md="6">
          <SendRanking
            v-if="showChild"
            :pageKind="rankingPageName"
            :biginDay="searchForm.dateFrom"
            :endDay="searchForm.dateTo"
            @catchSendMessage="displaySendMessage"
          />
        </v-col>
      </v-row>

      <v-row class="text-center">
        <v-col
          cols="12"
          md="3"
          v-for="(item, index) in items"
          :key="index"
          @click="onClickOpen(item)"
        >
          <Card :item="item" :loading="loading" />
        </v-col>
      </v-row>
    </div>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import axios from 'axios';
import { getBiginMonthDay, getEndMonthDay } from '@/utils/day.js';
import { generateMessage } from '@/utils/common.js';
import Card from '@/components/Common/Card.vue';
import RecieveRanking from '@/components/pages/Encouragements/RecieveRanking.vue';
import SendRanking from '@/components/pages/Encouragements/SendRanking.vue';
import config from '../../../const.js';
import message from '../../../message.js';
import { getSessionStorageItem, makeDateTimeStr } from '../../../common.js';

export default {
  name: 'Ranking',
  components: {
    Card,
    RecieveRanking,
    SendRanking,
  },

  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'プラスの氣 TOP',
          route: 'EncouragementsTop',
        },
        {
          name: 'プラスの氣 ランキング',
          route: 'EncouragementsRanking',
        },
      ],

      showContent: false,
      loading: false,
      searchForm: {
        dateFrom: '',
        dateTo: '',
      },
      userInfo: {},
      items: [],
      rankingPageName: config.PURASUNOKI_RANKING_PAGE,
      showChild: true,

      // 絞り込みボタン表示・非表示制御
      isNotProcess: true,
      isNotSendProcess: true,
      isNotRecvProcess: true,
    };
  },

  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    this.initializeSearchForm();

    this.isNotProcess = true;
  },

  /*
  mounted() {
    this.getRanking();
  },
  */

  methods: {
    displaySendMessage() {
      // 送信集計完了メッセージ受信
      this.isNotSendProcess = true;
      if (this.isNotRecvProcess) {
        // 絞り込みボタン表示
        this.isNotProcess = true;
        // ローディング終了
        this.loading = false;
      }
    },

    displayRecvMessage() {
      // 受信集計完了メッセージ受信
      this.isNotRecvProcess = true;
      if (this.isNotSendProcess) {
        // 絞り込みボタン表示
        this.isNotProcess = true;
        // ローディング終了
        this.loading = false;
      }
    },

    onClickOpen(item) {
      this.$refs.detail.open(item);
    },

    getRanking() {
      this.items = [];
      // ローディング画像表示
      this.loading = true;
      // 絞り込みボタン非表示
      this.isNotProcess = false;
      // 日付From Toチェック
      if (
        makeDateTimeStr('S', this.searchForm.dateFrom) >
        makeDateTimeStr('E', this.searchForm.dateTo)
      ) {
        // エラーの場合、メッセージ表示
        this.$refs.dialog.open('warning', message.MSG_WARN_DATE_ERROR);
        // 絞り込みボタン表示
        this.isNotProcess = true;
        // ローディング画像非表示
        this.loading = false;
        return this.initializeSearchForm();
      }
      // プラスの氣件数チェック
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/CommentSearchNum/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY +
            '/' +
            makeDateTimeStr('S', this.searchForm.dateFrom) +
            '/' +
            makeDateTimeStr('E', this.searchForm.dateTo)
        )
        .then((response) => {
          // プラスの氣データ件数取得
          if (response.data.SEARCH_NUM > config.PURASUNOKI_MAX_NUM) {
            // 絞り込み結果が500件を超えた場合
            let infoStr = message.MSG_WARN_RANKING_MAX_ERROR;
            let infoStrReplace = infoStr.replace(
              /a/g,
              config.PURASUNOKI_MAX_NUM
            );
            // 絞り込みボタン表示
            this.isNotProcess = true;
            this.$refs.dialog.open('info', infoStrReplace);
            return;
          } else {
            // 絞り込み結果が500件以下の場合、ランキングコンポーネントを再描画
            this.showChild = false;
            this.$nextTick(() => (this.showChild = true));

            // 受信・送信集計プロセス開始
            this.isNotSendProcess = false;
            this.isNotRecvProcess = false;
          }
        })
        .catch((error) => {
          if (error.response.status == 404) {
            return this.$refs.dialog.open(
              'error',
              generateMessage(message.NOT_FOUND, ['プラスの氣'])
            );
          }
          if (error.response.status == 400) {
            return this.$refs.dialog.open(
              'error',
              message.MSG_ERROR_SESSION + error
            );
          } else {
            return this.$refs.dialog.open(
              'error',
              message.MSG_ERROR_SYTEM + error
            );
          }
        })
        .finally(() => {
          // ローディング画像表示
          this.loading = false;
        });
    },

    initializeSearchForm() {
      this.searchForm.dateFrom = getBiginMonthDay();
      this.searchForm.dateTo = getEndMonthDay();
    },
  },
};
</script>
